
import { useState } from 'react';
import { PlayerContainer,VideoError } from './video.styles';
import ReactPlayer from "react-player";

type PlayerProps = {
    alt?:string;
    url:string;
    styles:{
        width:string
        height:string
    };
}


const Player = ({url,styles,alt}:PlayerProps) => {
    const [error,setError] = useState(false)
    const {height,width} = styles
    return (
        <PlayerContainer>
            {error ?
            <div style={{margin:'auto',backgroundColor:'',display:'flex'}}>
                <VideoError
                    src={alt}
                    // width={width}
                    // height={height}
                />
            </div>
            :
            <ReactPlayer
                src={`${url}?fullscreen=1`}
                width={width}
                height={height}
                controls
                playsInline
                onError={() => setError(true)}
            />          
            }
        </PlayerContainer>
    )
}

export default Player